// Notification.js
import React from 'react';
import { motion } from 'framer-motion';
import './Notification.css';
 
const NotificationStyle = ({ name, message, onClose }) => {
  return (
    <motion.div 
      className="notification"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
    >
      <div className="notification-icon">
        <img src="/teams-icon.png" alt="Teams" />
      </div>
      <div className="notification-content">
        <div className="notification-name">{name}</div>
        <div className="notification-message">{message}</div>
      </div>
      <div className="notification-actions">
        <button onClick={onClose}>Replyed</button>
      </div>
    </motion.div>
  );
};
 
export default NotificationStyle;